import { Grid, Heading, Stack, Text } from '@chakra-ui/react';
import LogoutButton from 'components/LogoutButton';
import { Card } from 'layout/Card';
import PageMetatags from 'layout/PageMetatags';
import { PublicPageLayout } from 'layout/PublicPageLayout';
import { useTranslation } from 'react-i18next';

const Page403 = () => {
  const { t } = useTranslation();

  return (
    <PublicPageLayout>
      <PageMetatags title={t('errors:403.meta.title')} />
      <Grid w="full" h="full" placeItems="center">
        <Card p={{ base: 2, lg: 20 }} textAlign="center" borderWidth={2} minW={'60%'}>
          <Stack spacing={8} alignItems={'center'}>
            <Heading size={'lg'}>{t('errors:403.meta.title')}</Heading>
            <Stack spacing="2" maxW="50ch">
              <Text fontSize={'lg'}>{t('errors:403.description')}</Text>
            </Stack>
            <LogoutButton variant="primary" justifyContent="center" paddingInline={6} showIcon={false} />
          </Stack>
        </Card>
      </Grid>
    </PublicPageLayout>
  );
};

export default Page403;
